import { Options, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ToastSeverity } from "primevue/api";

const GlobalMessageModule = namespace("globalMessage");

@Options({})
export class LayoutMixin extends Vue {
  @GlobalMessageModule.Getter("getMessage")
  protected globalMessage: any;

  @GlobalMessageModule.Action("resetMessages")
  protected resetGlobalMessageAction: any;

  @Watch("globalMessage", { immediate: true, deep: false })
  private onGlobalMessageChange(globalMessage: any): void {
    if (globalMessage?.type) {
      switch (globalMessage.type) {
        case "error":
          {
            const successMsg = this.$t("general.error");
            setTimeout(() => {
              this.$toast.add({
                severity: ToastSeverity.ERROR,
                summary: successMsg,
                detail: globalMessage.text,
                life: 3000,
              });
            }, 500);
          }
          break;
        case "success":
          {
            const successMsg = this.$t("general.success");
            setTimeout(() => {
              this.$toast.add({
                severity: ToastSeverity.SUCCESS,
                summary: successMsg,
                detail: globalMessage.text,
                life: 3000,
              });
            }, 500);
          }
          break;
        default:
          {
            const successMsg = this.$t("general.info");
            setTimeout(() => {
              this.$toast.add({
                severity: ToastSeverity.INFO,
                summary: successMsg,
                detail: globalMessage.text,
                life: 3000,
              });
            }, 500);
          }
          break;
      }
      this.resetGlobalMessageAction();
    }
  }
}
